const MAPBOX_GL_VERSION = 'v3.24.0'
const MAPBOX_TOKEN = 'pk.eyJ1Ijoic3R1ZGlvZm9ybS1jcyIsImEiOiJjbWo4dGk5eDAwMGt1M2ZyOXA1ZmRlOW92In0.8eJ1_igV9YV9JDAOv1vSWw'
const MAPBOX_CSS_URL = `https://api.mapbox.com/mapbox-gl-js/${MAPBOX_GL_VERSION}/mapbox-gl.css`
const MAPBOX_JS_URL = `https://api.mapbox.com/mapbox-gl-js/${MAPBOX_GL_VERSION}/mapbox-gl.js`

let activeMaps = []
let activeRun = 0
let mapboxLoader = null

function loadMapbox() {
	if (window.mapboxgl) {
		return Promise.resolve(window.mapboxgl)
	}

	if (mapboxLoader) {
		return mapboxLoader
	}

	if (!document.querySelector('link[data-mapbox-gl]')) {
		const link = document.createElement('link')
		link.href = MAPBOX_CSS_URL
		link.rel = 'stylesheet'
		link.dataset.mapboxGl = 'true'
		document.head.appendChild(link)
	}

	mapboxLoader = new Promise((resolve, reject) => {
		const existingScript = document.querySelector('script[data-mapbox-gl]')

		if (existingScript) {
			existingScript.addEventListener('load', () => resolve(window.mapboxgl), { once: true })
			existingScript.addEventListener('error', reject, { once: true })
			return
		}

		const script = document.createElement('script')
		script.src = MAPBOX_JS_URL
		script.async = true
		script.dataset.mapboxGl = 'true'
		script.addEventListener('load', () => {
			if (window.mapboxgl) {
				resolve(window.mapboxgl)
			} else {
				reject(new Error('Mapbox GL did not initialise'))
			}
		}, { once: true })
		script.addEventListener('error', reject, { once: true })
		document.head.appendChild(script)
	})

	return mapboxLoader
}

export default function initMap() {
	const run = ++activeRun
	const containers = Array.from(document.querySelectorAll('[data-map]'))

	activeMaps.forEach(map => map.remove())
	activeMaps = []

	if (!containers.length) return

	loadMapbox()
		.then(mapboxgl => {
			if (run !== activeRun) return

			mapboxgl.accessToken = MAPBOX_TOKEN

			containers.forEach(container => {
				if (!document.documentElement.contains(container)) return

				const longitude = Number(container.dataset.mapLongitude)
				const latitude = Number(container.dataset.mapLatitude)
				const zoom = Number(container.dataset.mapZoom || 9)

				if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) return

				container.replaceChildren()

				const map = new mapboxgl.Map({
					container,
					style: 'mapbox://styles/mapbox/standard',
					center: [longitude, latitude],
					zoom: Number.isFinite(zoom) ? zoom : 9,
					scrollZoom: false,
				})

				container.mapboxMap = map
				activeMaps.push(map)
				map.addControl(new mapboxgl.NavigationControl())

				if (container.dataset.mapLink) {
					const mapPin = document.createElement('a')
					mapPin.className = 'map-pin'
					mapPin.href = container.dataset.mapLink
					mapPin.target = '_blank'
					mapPin.rel = 'noopener noreferrer'
					mapPin.setAttribute('aria-label', 'Open map directions')

					new mapboxgl.Marker({
						element: mapPin,
					})
						.setLngLat([longitude, latitude])
						.addTo(map)
				}
			})
		})
		.catch(() => {
			containers.forEach(container => container.classList.add('is-map-unavailable'))
		})
}
